export default "__VITE_ASSET__0c55a3bb__"